import { ReactNode, useEffect } from 'react'
import { useAuth } from '../../Hooks/Auth'
import { useNavigate } from 'react-router-dom'

interface Props {
  children: ReactNode
  permissions: string[]
  page?: boolean
}

export function Can({ children, permissions, page = false }: Props): JSX.Element | null {
  const { user } = useAuth()
  const navigate = useNavigate()


  const hasPermission = user ? (
    permissions.some(p => user.permissionsScreens?.includes(p)) || 
    user.permissionsScreens?.includes('all') ||
    permissions.some(p => {
      const isHCP = p.startsWith('menu:hcp') || p.startsWith('feature:hcp-');
      return isHCP ? user.permissionsScreens?.includes('all:hcp') : user.permissionsScreens?.includes('all:hub');
    })
  ) : false;

  useEffect(() => {
    // Só redireciona se for uma proteção de PÁGINA inteira e o usuário logado não tiver acesso
    if (page && user && !hasPermission) {
      navigate('/denied')
    }
  }, [user, hasPermission, navigate, page])

  // Se não estiver logado ou não tiver nenhuma permissão básica, bloqueia tudo
  if (!user || user?.permissions?.length === 0) {
    return null
  }

  // Se não tiver a permissão específica, não renderiza o conteúdo (esconde o menu ou botão)
  if (!hasPermission) {
    return null
  }

  return <>{children}</>
}
